
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album/[album]",
      function () {
        return require("private-next-pages/album/[album].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/album/[album]"])
      });
    }
  